import { render, staticRenderFns } from "./NativeWebPush.vue?vue&type=template&id=3c8231e2&scoped=true"
import script from "./NativeWebPush.vue?vue&type=script&lang=js"
export * from "./NativeWebPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8231e2",
  null
  
)

export default component.exports